// frontend/src/services/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://justerps.com/api',
  timeout: 60000,
  withCredentials: true
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    console.log('🔐 Adding token to request:', token ? 'Yes' : 'No');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log('🚀 API Request:', config.method?.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error('❌ Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    console.log('✅ API Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('❌ API Error:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: error.message
    });
    
    // Handle 401 Unauthorized (token expired/invalid)
    if (error.response?.status === 401) {
      console.log('🔄 401 Unauthorized - Clearing token');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/signIn';
    }
    
    return Promise.reject(error);
  }
);

export default api;
